import React, { useEffect, useMemo } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Input, DateInput,  Radio, TextArea } from "@components/form";
import { post, put } from "@utils/axios_api";
import { validateDuplicateEmail } from "@utils/validation";
import { useQueryClient } from '@tanstack/react-query';

function InstructorForm({ selectedData, onSaved, onAdd }) {
    const defaultFormValues = useMemo(() => ({
      instructorId: "",
      instructorNm: "",
      birthDt: "",
      genderCd: "",
      phoneNo: "",
      email: "",
      zipcode: "",
      address1: "",
      address2: "",
      belong: "",
      introduction: "",
      career: "",
      outYn: "N",
      instructPee: "",
    }),[]);

  const methods = useForm({
    defaultValues: defaultFormValues, // defaultValues : react-hook-form 초기값 설정 옵션
  });

  const { reset, setValue, handleSubmit  } = methods;
  const isEdit = useMemo(() => !!selectedData, [selectedData]); // 수정 모드, 등록 모드 판별
  const queryClient = useQueryClient();


  /* ---------- 선택 행 → 폼 세팅 ---------- */
  // 목록에서 선택한 값 세팅
  // useEffect(() => {
  //   if (isEdit) {
  //     reset(defaultFormValues);
  //   } 
  // }, [isEdit, selectedData, reset, defaultFormValues]);


  useEffect(() => {
    isEdit ? reset(selectedData) : reset(defaultFormValues); // [MOD] reset 로직 보강
  }, [isEdit, selectedData, reset, defaultFormValues]);

  // // 패스워드 등록/수정 모드 세팅
  // useEffect(() => {
  //   unregister("password");
  //   // 다시 등록
  //   register("password", isEdit ? {} : { required: "비밀번호를 입력하세요." });
  //   // 수정 모드일 때 password 값은 항상 비워놓음
  //   setValue("password", "");
  // }, [isEdit, register, unregister, setValue]);

  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        setValue("zipcode", data.zonecode, { shouldValidate: true });
        setValue("address1", data.address, { shouldValidate: true });
      },
    }).open();
  };

  const handleAdd = () => {
    reset(defaultFormValues);
    onAdd && onAdd();
  };

  const onSubmit = async (formData) => {
    try {
      let response;
        if (isEdit) {
            if (!formData.password) {
                delete formData.password;
              }
            response = await put("/admin/ins/updateInstructor", formData);
        } else {
            response = await post("/admin/ins/insertInstructor", formData);
        }

        alert(response?.message || "저장 성공");
        await queryClient.invalidateQueries({ queryKey: ["instructorList"] });

        // onSaved && onSaved();
    } catch (err) {
      console.error(err);
      alert("등록/수정 실패");
    }
  };

  const onError = () => {
    alert("필수 입력란을 확인하세요.");
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit, onError)} >
        <div className="section-tit-wrap">
            <h3 className="border-left-primary">&nbsp;강사 등록/수정</h3>
            <div className="btn-right-box">
            <ul>
                <li><button type="button" title="추가" className="btn-add" onClick={handleAdd}>추가</button></li>
                <li><button type="submit" title="저장" className="btn-save">저장</button></li>
            </ul>
            </div>
        </div>

        <table className="table-write">
            <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "40%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "40%" }} />
            </colgroup>
            <tbody>
            <tr>
                <th>아이디<span className="red">*</span></th>
                <td>
                <Input
                  name="instructorId"
                  readOnly={isEdit}
                  disabled
                  placeholder="자동 생성"
                  className="input-text"
                  style={{ width: "100%" }}
                />
                </td>
                <th>강사명<span className="red">*</span></th>
                <td>
                <Input
                    name="instructorNm"
                    placeholder="강사명"
                    className="input-text"
                    style={{ width: "100%" }}
                    rules={{ required:"강사명을 입력하세요" }}
                    />
                </td>
            </tr>
            <tr>
                <th>전화번호<span className="red">*</span></th>
                <td>
                <Input
                  name="phoneNo"
                  placeholder="ex) 010-1234-5678"
                  className="input-text"
                  style={{ width: "100%" }}
                  rules={{
                    required: "전화번호를 입력하세요.",
                    pattern: {
                      value: /^\d{2,3}-\d{3,4}-\d{4}$/,
                      message: "예) 010-1234-5678 형식으로 입력",
                    },
                  }}
                />
                </td>
                <th>이메일<span className="red">*</span></th>
                <td>
                <Input
                    name="email"
                    placeholder="이메일"
                    className="input-text"
                    style={{ width: "100%" }}
                    rules={{
                        required: "이메일을 입력하세요.",
                        pattern: {
                            value: /^[A-Za-z0-9@.]+$/,
                            message: "이메일 형태로 작성해주세요"
                          },
                        validate: (value) => {
                            if (selectedData && value === selectedData.email) {
                              return true;
                            }
                            return validateDuplicateEmail(value);
                          },
                    }}
                    />
                </td>
            </tr>
            <tr>
                <th>생년월일 <span className="red">*</span></th>
                <td>
                <DateInput 
                    name="birthDt"
                    style={{width:"100%"}}
                    rules={{ required:"생년월일을 선택해주세요" }} />
                </td>
                <th>성별</th>
                <td>
                <div style={{display:"flex", gap:"15px"}}>
                  <Radio name="genderCd" label="남자" value="M" />
                  <Radio name="genderCd" label="여자" value="F" />
                </div>
                </td>
            </tr>
            <tr>
                <th>소속</th>
                <td>
                <Input
                    name="belong"
                    placeholder="소속"
                    className="input-text"
                    style={{ width: "100%" }}
                    />
                </td>
                <th>외부여부 <span className="red">*</span></th>
                <td>
                <div style={{display:"flex", gap:"15px"}}>
                  <Radio name="outYn" label="내부" value="N" />
                  <Radio name="outYn" label="외부" value="Y" />
                </div>
                </td>
            </tr>
            <tr>
                <th>강사료(시간당)<span className="red">*</span></th>
                <td colSpan="3">
                <Input
                    name="instructPee"
                    placeholder="강사료"
                    className="input-text"
                    style={{ width: "45%" }}
                    inputMode="numeric"          /* [MOD] 모바일 키패드 유도 */
                    maxLength={7}                /* [MOD] 7자리 제한 */
                    rules={{ required: "강사료를 입력하세요", pattern: { value: /^\d{0,7}$/, message: '숫자만(최대 7자리)' } }}
                    />
                </td>
            </tr>
            <tr>
                <th>주소</th>
                <td colSpan={3}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '8px', display:'flex' }}>
                      <Input
                        name="zipcode"
                        placeholder="우편번호"
                        readOnly
                        className="input-text"
                        style={{width:"100%"}}
                      />
                      <button
                        type="button"
                        className="btn-add btn-form-search"
                        onClick={handleAddressSearch}
                        style={{marginLeft:"10px"}} >
                        검색
                      </button>
                    </div>
                    <div>
                      <Input
                        name="address1"
                        placeholder="주소"
                        readOnly
                        className="input-text"
                        maxLength={30}
                        style={{width:"100%", marginBottom:"10px"}}
                      />
                      <Input
                        name="address2"
                        placeholder="상세주소를 입력하세요"
                        className="input-text"
                        maxLength={30}
                        style={{width:"100%"}}
                      />
                    </div>
                  </div>
                </td>
            </tr>
            <tr>
                <th>소개</th>
                <td colSpan="3">
                    <TextArea
                        name="introduction"
                        className="area"
                        autoResize
                        placeholder="강사소개"
                    />
                </td>
            </tr>
            <tr>
                <th>경력</th>
                <td colSpan="3">
                    <TextArea
                        name="career"
                        className="area"
                        autoResize
                        placeholder="강사경력"
                    />
                </td>
            </tr>
            </tbody>
        </table>
      </form>
    </FormProvider>
  );
}

export default InstructorForm;
